var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"small px-2 py-1 badge text-white",class:_vm.isEnabled ? '' : 'badge-secondary',style:({
    'background-color': _vm.isEnabled ? _vm.color : '',
  })},[_c('i',{class:_vm.isEnabled ? 'fas fa-circle-check pr-1' : 'fas fa-circle-xmark pr-1'}),_vm._v(" "+_vm._s(_vm.isEnabled ? _vm.$t('billingPlan.enabled') : _vm.$t('billingPlan.disabled'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }